<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
        <v-icon>dynamic_feed</v-icon>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;Manejo de Denuncia</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)">
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col>
            <v-autocomplete
              v-model="filtro.empresaId"
              :items="empresas"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="De la Empresa"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-select
              label="Motivo:"
              v-model="filtro.motivoId"
              :items="motivos"
              item-text="descripcion"
              item-value="id"
              placeholder="Seleccione uno"></v-select>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="2">
            <v-text-field
              v-model="filtro.documento"
              label="Buscar por documento"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              label="Estados:"
              v-model="filtro.estadosId"
              :items="estados"
              autocomplete="disabled"
              item-text="descripcion"
              item-value="id"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              label="Estado Debito"
              v-model="filtro.estadoDebitoId"
              :items="estadosDebito"
              autocomplete="disabled"
              item-text="descripcion"
              item-value="id"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"></v-autocomplete>
          </v-col>
          <v-col cols="2">
            <v-btn color="success" @click="getItems(true)" :disabled="loading"
              >Consultar</v-btn
            >
          </v-col>
          <v-col>
            <v-btn color="orange" @click="generarArchivoConsulta">
              Exportar &nbsp;
            </v-btn>
          </v-col>
          <v-col>
            <v-btn color="orange" @click="generarReporte">
              Reporte &nbsp;
            </v-btn>
          </v-col>
        </v-row>

        <v-flex>
          <v-card>
            <v-toolbar dense :color="$store.state.UiColors.crudToolbarList">
              <v-icon>list</v-icon>
              <v-toolbar-title class="font-weight-light">Lista</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-data-table
              loading-text="Buscando registros"
              dense
              :headers="headers"
              :items="records"
              :rows-per-page="pagination.itemsPerPage"
              :options.sync="pagination"
              v-model="selectedRows"
              :loading="loading"
              class="elevation-1"
              :footer-props="footer"
              item-key="id">
              <template slot="no-data">
                <v-alert :value="true" color="grey" icon="warning">
                  No se encontraron registros con los filtros ingresados
                </v-alert>
              </template>
              <template v-slot:item="{ item }">
                <tr>
                  <td class="text-xs-left caption">{{ item.persona }}</td>
                  <td class="text-xs-left caption">{{ item.documento }}</td>
                  <td class="text-xs-left caption">{{ item.empresa }}</td>
                  <td class="text-xs-left caption">{{ item.motivo }}</td>
                  <td class="text-xs-left caption">{{ item.tipo }}</td>

                  <td class="text-xs-left caption">{{ item.origen }}</td>

                  <td class="text-xs-left caption">{{ item.estadoCredito }}</td>

                  <td class="text-xs-left caption">
                    {{ item.estadoCreditoConDenuncia }}
                  </td>
                  <td class="text-xs-left caption">
                    {{
                      item.fechaRecepcion
                        | dateParse("YYYY-MM-DD")
                        | dateFormat("DD-MM-YYYY")
                    }}
                  </td>
                  <td
                    class="text-xs-left caption"
                    v-if="item.fechaContestacion">
                    {{
                      item.fechaContestacion
                        | dateParse("YYYY-MM-DD")
                        | dateFormat("DD-MM-YYYY")
                    }}
                  </td>
                  <td
                    class="text-xs-left caption"
                    v-if="!item.fechaContestacion">
                    {{ "Pendiente" }}
                  </td>
                  <td class="text-xs-left caption">
                    {{
                      item.fechaAudiencia
                        | dateParse("YYYY-MM-DD")
                        | dateFormat("DD-MM-YYYY")
                    }}
                  </td>
                  <td class="text-xs-left caption">
                    <v-chip small :color="item.empresaColor" label dark>{{
                      item.empresaShort
                    }}</v-chip>
                  </td>
                  <td>
                    <v-icon small @click="editItem(item)">edit</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-row dense>
              <v-col>
                <v-btn @click.stop="altaReclamo()" color="blue" dark>
                  Dar de Alta una Nueva Denuncia</v-btn
                >
                &nbsp;
              </v-col>
            </v-row>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>

    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>

      Model: {{ filtro }}
      <p></p>
    </template>
  </v-container>
</template>

<script>
import { http } from "@/axios";
//import Vue from "vue";
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from "vuex";

export default {
  data() {
    return {
      showSaveProgress: false,
      saving: false,
      downloading: false,
      primeraBusquedaRealizada: false,
      loading: false,
      editMode: false,
      suspend: false,
      filterChanged: false,
      search: "", // valor para búsqueda
      pagination: {
        // definición de paginación
        sortDesc: [true],
        sortBy: [""],
        page: 1,
        itemsPerPage: 5,
      },
      footer: {
        showFirstLastPage: true,
        //itemsPerPageOptions:[5,10,20, 50, 'All'],
        showCurrentPage: true,
      },
      totalItems: 0, // va afuera de pagination
      headers: [
        // definición de columnas
        { text: "Solicitante Denuncia", value: "persona" },
        { text: "Documento", value: "documento" },
        { text: "Empresa Denunciada", value: "empresa" },
        { text: "Motivo", value: "motivo", width: 150 },
        { text: "Tipo", value: "tipo" },

        { text: "Origen", value: "origen" },
        { text: "Estado Credito", value: "estadoCredito" },
        {
          text: "Estado Credito con Denuncia",
          value: "estadoCreditoConDenuncia",
        },
        { text: "Fecha Recepcion", value: "fechaRecepcion" },
        { text: "Fecha Contestacion", value: "fechaContestacion" },
        { text: "Fecha Audiencia", value: "fechaAudiencia" },
        { text: "Empresa", value: "empresaShort", width: 100 },
        { text: "Acciones", width: 100 },
      ],
      records: [], // registros
      selectedRows: [],
      filtro: {
        documento: null,
        personaId: "00000000-0000-0000-0000-000000000000",
        estadosId: 0,
        empresaId: 0,
        motivoId: 0,
        estadoDebitoId: 0,
      },
      estadosBcra: [
        { nombre: "Cualquiera", status: 0 },
        { nombre: "Abierto", status: 1 },
        { nombre: "Cerrado", status: 2 },
      ],
      empresas: [],
      estados: [],
      motivos: [],
      estadosDebito: [],
    };
  },
  async created() {
    this.loadEmpresas();
    this.loadEstados();
    this.loadEstadosDebito();
    this.loadMotivos();
  },
  watch: {
    /* pagination :{
        handler(){
          if(this.primeraBusquedaRealizada)
            this.getItems(false);
        },
        deep: true
    }, */
    search() {
      this.getItems(true);
    },
  },
  computed: {
    ...mapGetters(["getActionFromLink", "user", "checkCanAccess"]),
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
    formatoSeleccionado() {
      if (!this.filtro.formatoId) return null;
      console.log(
        this.formatos.filter((e) => e.id == this.filtro.formatoId)[0]
      );
      return this.formatos.filter((e) => e.id == this.filtro.formatoId)[0];
    },
  },
  methods: {
    ...mapMutations([
      "setActiveTask",
      "setActiveSubTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
      "setReporteActivo",
    ]),
    ...mapActions(["setStatusTareaFrecuente"]),
    selectAllChanged(toggle) {
      this.selectedRows = [];
      if (toggle) {
        for (let index = 0; index < this.records.length; index++) {
          const element = this.records[index];

          this.selectedRows.push(element);
        }
      }
    },
    async getItems(resetPagination) {
      // if (this.filtro.empresaId == 0) {
      //   this.alertWarning("Debe elegir una Empresa.");
      //   return;
      // }

      //Hago esto para que si cambias los filtros y tocas consultar traiga los resultados de la primera página
      if (resetPagination) {
        this.pagination.page = 1;
      }
      if (this.filtro.documento)
        await this.getPersonaDocumento(this.filtro.documento);

      this.loading = true;
      this.$validator.reset();

      let filter = this.filtro;

      try {
        var result = await http.get(
          "gestion/listdenuncias?empresaId=" +
            filter.empresaId +
            "&personaId=" +
            filter.personaId +
            "&estadoCreditoId=" +
            filter.estadosId +
            "&motivoId=" +
            filter.motivoId +
            "&debitoId=" +
            filter.estadoDebitoId
        );

        this.selectedRows = [];
        this.records = result.list;
        this.totalItems = result.totalCount;
        console.log(result);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.primeraBusquedaRealizada = true;
      this.loading = false;
    },
    async generarArchivoConsulta() {
      this.loading = true;
      try {
        self.loading = true;

        await http
          .post(
            "filegeneration/archivomanejodenuncias",
            JSON.stringify({
              empresaId: this.filtro.empresaId,
              personaId: this.filtro.personaId,
              estadoCreditoId: this.filtro.estadosId,
              motivoId: this.filtro.motivoId,
              estadoDebitoId: this.filtro.estadoDebitoId,
            })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              this.alertError(resp.error);
            } else {
              this.alertSuccess(
                "Se generó correctamente el archivo. Aguarde unos instantese mientras se descarga el archivo..."
              );
              console.log(resp);
              this.loading = true;
              this.downloadFile(resp, "ConsultaManejoDeDenuncias.csv");
              this.loading = false;
            }
          })
          .catch((e) => {
            this.alertError(e);
          });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async generarReporte() {
      // validaciones

      var self = this;

      try {
        self.loading = true;

        let params = [];
        params.push({
          EmpresaId: this.filtro.empresaId,
          PersonaId: this.filtro.personaId,
          estadoCreditoId: this.filtro.estadosId,
          MotivoId: this.filtro.motivoId,
          EstadoDebitoId: this.filtro.estadoDebitoId,
        });

        this.setReporteActivo({
          reporte: "Consulta Manejo De Denuncias.trdp",
          params: params,
        });
        window.open("/report-viewer");
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },

    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get("empresas");

        this.empresas = result.list;
        this.empresas.unshift({ id: 0, nombre: "(Cualquiera)" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadEstados() {
      this.loading = true;
      try {
        var result = await http.get("tiposcreditodenuncia");

        this.estados = result.list;

        this.estados.unshift({ id: 0, descripcion: "(Cualquiera)" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async downloadFile(file) {
      //convierto el string del path a base64 para poder mandarlo
      let base64String = "";
      base64String = btoa(file.fullPath);

      http
        .get("filemanagement/getfilebypath/" + base64String)
        .then((resp) => {
          let dataType = "";
          switch (resp.extension) {
            case ".doc":
            case ".docx":
            case ".DOC":
            case ".DOCX":
              dataType = "data:application/vnd.ms-word";
              break;
            case ".pdf":
            case ".PDF":
              dataType = "data:application/pdf";
          }

          console.log(resp.fileName);

          //necesito hacer esto del arrayBuffer para que despues se pueda hacer el blob
          var arrayBuffer = this.base64ToArrayBuffer(resp.file);
          this.saveByteArray(resp.fileName, arrayBuffer, dataType);
        })
        .catch((e) => this.alertError(e));
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(fileName, byteArrayBuffer, dataType) {
      var blob = new Blob([byteArrayBuffer], { type: dataType });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
    async loadMotivos() {
      this.loading = true;
      try {
        var result = await http.get("tiposmotivodenuncia");

        this.motivos = result.list;

        this.motivos.unshift({ id: 0, descripcion: "(Cualquiera)" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadEstadosDebito() {
      this.loading = true;
      try {
        var result = await http.get("tiposdebitosdenuncia");

        this.estadosDebito = result.list;

        this.estadosDebito.unshift({ id: 0, descripcion: "(Cualquiera)" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async getPersonaDocumento(documento) {
      var result = await http.get(
        "personas/listapordocumento?documento=" +
          documento +
          "&withAvisos=false&withAvatars=false"
      );
      //alert(JSON.stringify(result.list));
      this.personaId = result.list[0].id;
      //this.filtro.personaId = this.personaId;
      this.filtro.personaId = result.list[0].id;
    },
    altaReclamo() {
      var params = {
        width: 900,
        visible: true,
      };

      this.setActiveTask({ task: "app-alta-denuncia", props: params });
    },
    editItem(item) {
      var params = {
        width: 900,
        visible: true,
        denuncia: item,
      };

      this.setActiveTask({ task: "app-modifica-denuncia", props: params });
    },
  },
};
</script>
